// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1QhQk","productName":"Table_productName__3yK9z"};